function AccountFormCtrl($scope, $controller, $location,  $timeout, $state, $filter, TimeZoneService) {
    $state.params.model = 'account';
    $state.params.id = $scope.params.accountId;
    $controller('FormCtrl', { $scope: $scope, $controller: $controller, $location: $location, $timeout: $timeout, $state: $state });

    $scope.formData = {
        users: [],
    };

    TimeZoneService.getTimeZones(function(timeZones) {
        $scope.timezones = timeZones;
    });

    $scope.accountProductionTypes = [
        {
            name: 'Production',
            value: 'PRODUCTION',
        }, {
            name: 'Development',
            value: 'DEVELOPMENT',
        },
    ];

    $scope.afterFetch = function () {
        if ($scope.accountTypes && $scope.accountTypes instanceof Array) {
            $scope.formData.accountType = $scope.accountTypes[0].name;
        }
        $scope.formData.showMsa = true;
    };


    store.fetch({
        path: '/accountTypes',
        method: 'GET',
        success: function (data) {
            $timeout(function () {
                $scope.accountTypes = data.items;
                $scope.accountTypes.forEach(function (item) {
                    item.displayName = $filter('capitalize')(item.name);
                });

                $scope.formData.accountType = $scope.accountTypes[0].name;
            }, 0);
        },
    });

     // set scope param to
    if (isSystemLogin) {
        $scope.isSystemLogin = true;
    }

    $scope.existingResellerAdminsCollection = function (state, params) {
        store.fetch({
            path: '/existingResellerAdmins?parentAccountId=' + $state.params.id,
            success: function (data) {
                $timeout(function () {
                    $scope.existingResellerAdmins = data.items;
                }, 0);
            },
        });
    };
    $scope.existingResellerAdminsCollection();

    $scope.catoAdminsCollection = function (state, params) {
        if ($state.params.id === 1) {
            $scope.$watch("existingResellerAdmins", function(newVal, oldVal){
                $scope.catoAdmins = angular.copy($scope.existingResellerAdmins );
            });
        }
        else {
            store.fetch({
                path: '/existingResellerAdmins?parentAccountId=1',
                success: function (data) {
                    $timeout(function () {
                        $scope.catoAdmins = data.items;
                    }, 0);
                },
            });
        }
    };
    $scope.catoAdminsCollection();

    $scope.preSave = function() {
        if ($scope.formData.existingAdmin) {
            $scope.formData.users = [];
        } else {
            delete $scope.formData.existingAdminId;
        }
    };

    store.fetch({
        path: '/getReleaseGroups',
        success: function (data) {
            $timeout(function () {
                $scope.releaseGroups = data;
                var releaseGroupToRandom = ['group_b', 'group_c', 'group_d'];
                var randReleaseGroup = Math.floor(Math.random() * releaseGroupToRandom.length);
                $scope.formData.releaseGroup = releaseGroupToRandom[randReleaseGroup];
            }, 0);
        },
    });
}
